import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";

const styles = createUseStyles((theme) => ({
  inputGroupWrapper: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "nowrap",
    width: "100%",
    border: "1px solid " + colors.gray300,
    borderRadius: "8px",
    "& span": {
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "24px",
      color: colors.gray600,
      margin: "auto 0px auto 12px",
    },
    "&:focus": {
      outline: "none",
    },
  },
  expenditure: {
    "&:focus": {
      boxShadow: "none",
    },
  },
  currencyLabel: {
    display: "flex",
    alignItems: "center",
    margin: "0px !important",
    padding: "0px 14px",
    borderRadius: "6px",
    backgroundColor: ({ disabled }) =>
      disabled ? colors.gray50 : colors.white,
  }
}));

export default styles;

export const expenditureSelect = {
  menu: (base) => ({
    ...base,
    // override border radius to match the box
    borderRadius: "8px",
    right: -1,
    marginTop: "4px",
    boxShadow: `0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08);`,
    border: `1px solid ${colors.lightGrey}`,
    width: "auto",
  }),
  option: (base, state) => {
    return {
      ...base,
      cursor: "pointer",
      overflow: "hidden",
      img: {
        display: state.isSelected ? "inline" : "none",
        marginLeft: "6px",
      },
      display: "flex",
      padding: "10px 8px",
      backgroundColor: state.isSelected ? colors.brightBlue : colors.white,
      borderRadius: "6px",
      color: colors.gray900,
      "&:hover": {
        backgroundColor: colors.brightBlue,
      },
      "& span": {
        color: colors.mediumGrey,
        marginLeft: "5px",
      },
      position: "relative",
      "&::after": {
        content: '""',
        display: "block",
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%",
      },
    };
  },
  control: (base, state) => ({
    ...base,
    height: "44px",
    width: "max-content",
    borderWidth: "0px",
    borderRight: "none",
    borderRadius: "8px",
    borderColor: colors.gray300,
    backgroundColor: state.isDisabled ? colors.gray50 : colors.white,
    "&:hover": {
      borderColor: colors.gray300,
    },
    // Removes weird border around container
    boxShadow: null,
    minHeight: "40px",
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0px",
    height: "44px",
  }),
  input: (base) => ({
    ...base,
    height: "44px",
    minWidth: "40px",
    margin: "0px",
    padding: "0px",
  }),
  singleValue: (base) => ({
    ...base,
    marginLeft: "0px",
    marginRight: "8px",
    padding: "0px",
    color: colors.gray900,
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    paddingRight: "14px",
    paddingLeft: "0px",
    color: colors.inactiveGrey,
    "&:hover": {
      color: colors.inactiveGrey,
    },
  }),
};
